import {observer} from "mobx-react";
import React, {ReactElement} from "react";
import {ExpandComponentProps} from "../../core/grid/component/gridComp";
import {ProjectVersionMaterial} from "../domain/project/projectVersionMaterialDomain";
import MdField from "../../core/metamodel/mdField";

@observer
export default class ProjectVersionMaterialExpandComp extends React.Component<ExpandComponentProps, null> {

  fieldsRow1 : string[] = ['code', 'name', 'originalMaterial']
  fieldsRow2 : string[] = ['volume', 'lifespan', 'area']
  fieldsRow3 : string[] = ['primaryEnergy', 'lifespan', 'comment']
  fieldsRow4 : string[] = ['co2Equivalent', 'so2Equivalent', 'po4Equivalent']
  fieldsRow5 : string[] = ['r11Equivalent', 'c2h4Equivalent', 'thermalCoefficient']
  fieldsRow6 : string[] = ['renewableWeight', 'recycledWeight', 'regionallyMadeWeight']
  fieldsRow7 : string[] = ['epdcertification', 'pefcCertificationWeight', 'pefcRequestWeight']

  fieldRows = [this.fieldsRow1, this.fieldsRow2,this.fieldsRow3,this.fieldsRow4,this.fieldsRow5,this.fieldsRow6,this.fieldsRow7]

  getFormattedValue = (field : MdField) => {
    let material = this.props.item.rowObject as ProjectVersionMaterial;
    if (field.fieldName === 'originalMaterial') {
      return material.originalMaterial.label
    }
    let value = material[field.fieldName];
    if (value === undefined) {
      return "-"
    }
    return field.formatValue(value);
  }

  renderCell = (field : MdField) : ReactElement => {

    return (<div className="fx col-xs-4">
      <div className="item-label" key={field.label}>{field.label}: </div>
      {this.getFormattedValue(field)}
    </div>)
  }

  renderRow = (columnsNames : string[]) : ReactElement => {
    let material = this.props.item.rowObject as ProjectVersionMaterial;
    let fields = material.$mdEntityRef.getFields();
    let cells = []

    for(let column of columnsNames) {
      let field = fields.find(f => f.fieldName === column);
      cells.push(this.renderCell(field))
    }

    return (<div className="row">
      {cells}
    </div>)
  }

  render() {
    let rows = [];
    for (let row of this.fieldRows) {
      rows.push(this.renderRow(row));
    }

    return (
        <div style={{paddingLeft : 25, marginBottom : 25}}>
          {rows}
        </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionMaterialExpandComp.tsx